export const FORECAST_UPPER_LIMIT = 1_000_000_000_000; // 内示数量の上限値（1兆）
export const EQUAL_RATE = 1; // 等倍（1倍）

export const MIN_OF_DISPLAY_FORECAST_MONTH = 3;
export const MAX_OF_DISPLAY_FORECAST_MONTH = 24;
export const DEFAULT_DISPLAY_FORECAST_MONTH = 4;

export const RECOMMENDED_ORDER_DATE_WHEN_NULL = {
  year: -1,
  month: -1,
  day: -1,
} as const; // 発注日がnullの場合の値

export const DISPLAY_VALUE_OF_RECOMMENDED_ORDER_DATE_WHEN_NULL = '-'; // 発注日がnullの場合の表示値
